import React from "react";
import PropTypes from "prop-types";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import { scaleFromLakhs, unitSuffix } from "../triangulation-format";

const SERIES = [
    { key: "gst", name: "GST", fill: "#2563eb" },
    { key: "ledger", name: "Ledger", fill: "#16a34a" },
    { key: "bank", name: "Bank", fill: "#f59e0b" }
];

const axisTick = { fontSize: 12, fill: "#8a93a3" };

/**
 * Monthly GST / Ledger / Bank grouped bar chart. Values are stored in ₹ lakhs
 * and scaled to the selected `unit` for display.
 */
const TriangulationChart = ({ data, unit }) => {
    const u = unit || "lacs";
    const suffix = unitSuffix(u);
    const scaled = (data || []).map(row => ({
        month: row.month,
        gst: scaleFromLakhs(row.gst, u),
        ledger: scaleFromLakhs(row.ledger, u),
        bank: scaleFromLakhs(row.bank, u)
    }));
    const fmt = value =>
        "₹" +
        Number(value).toLocaleString("en-IN", { maximumFractionDigits: 2 }) +
        suffix;
    return (
        <ResponsiveContainer width={"100%"} height={300}>
            <BarChart
                data={scaled}
                margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
                barGap={2}
                barCategoryGap={"20%"}
            >
                <CartesianGrid vertical={false} stroke={"#eef1f5"} />
                <XAxis
                    dataKey={"month"}
                    tickLine={false}
                    axisLine={{ stroke: "#e6e9ee" }}
                    tick={axisTick}
                    interval={0}
                />
                <YAxis
                    tickLine={false}
                    axisLine={false}
                    tick={axisTick}
                    width={44}
                />
                <Tooltip
                    cursor={{ fill: "rgba(37,99,235,0.06)" }}
                    formatter={value => [fmt(value)]}
                    contentStyle={{
                        borderRadius: 8,
                        border: "1px solid #e6e9ee",
                        fontSize: 12
                    }}
                />
                <Legend
                    iconType={"circle"}
                    wrapperStyle={{ fontSize: 12, paddingTop: 4 }}
                />
                {SERIES.map(s => (
                    <Bar
                        key={s.key}
                        dataKey={s.key}
                        name={s.name}
                        fill={s.fill}
                        radius={[3, 3, 0, 0]}
                        maxBarSize={18}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

TriangulationChart.propTypes = {
    data: PropTypes.array.isRequired,
    unit: PropTypes.string
};

export default TriangulationChart;
